import { render } from "./LogsLoading.vue?vue&type=template&id=87abb670"
import script from "./LogsLoading.vue?vue&type=script&lang=js"
export * from "./LogsLoading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__